<template>
  <v-bottom-nav
    :active="$route.name"
    :value="true"
    color="primary"
    @update:active="goToStep"
  >
    <v-btn
      v-for="(s, index) in customstates.states" :key="s.name"
      v-show="s.hidden===false"
      flat
      :value="s.name"
      dark
    >
      <span v-html="s.textName"></span>
      <i class="v-icon"><font-awesome-icon :icon="s.icon" v-if="s.icon" /></i>
    </v-btn>
  </v-bottom-nav>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    props: [],
    data () {
      return {
        currentRouteName: this.$route.name
      }
    },
    computed: {
      ...mapState([
        // map this.customband to store.state.customband
        'customband',
        'customstates'
      ])
    },
    methods: {
      goToStep (stepName) {
        this.$router.push({ name: stepName })
      },
      prevStep () {
        let currentRouteName = this.$route.name
        let previousRouteName = this.customstates.previousStateName(currentRouteName)
        this.$router.push({ name: previousRouteName })
      },
      nextStep () {
        let currentRouteName = this.$route.name
        let nextRouteName = this.customstates.nextStateName(currentRouteName)
        this.$router.push({ name: nextRouteName })
      }
    }
  }
</script>
